import { ERolesCode } from "../../../../../routes/role-catalog";

export const USER_NOT_VALID_TO_EDIT_EVALUATION = [
  ERolesCode.MEMBER,
  ERolesCode.STARTUP,
];
